module.exports = __webpack_public_path__ + "static/media/pvc-350x210.6fb0cefd.png";